import get from 'lodash/get';
import EventModel from '../models';

const trackShowOfferEvent = event => {
  const showOfferEvent = new EventModel(
    `Subscription Modal`,
    `piano – ${get(event, 'templateId', 'none')}`,
    `offer view`,
    `offer view`,
    `1 | 5`
  );

  showOfferEvent.addTrackingAttributes({
    id: get(event, 'offerId', 'none'),
    flow: get(event, 'templateid', 'none'),
    product: [
      {
        productInfo: {
          productID:
            'We dont have access to Resource ID this early in the offer',
          productName: get(event, 'offerId', 'none'),
          productOffer: `Product Offer`,
          productBasePrice: '19.99'
        }
      },
      {
        productInfo: {
          productID:
            'We dont have access to Resource ID this early in the offer',
          productName: get(event, 'offerId', 'none'),
          productOffer: `Product Offer`,
          productBasePrice: '1.99'
        }
      }
    ]
  });

  showOfferEvent.triggerTrackingEvent(
    'offer-modal',
    showOfferEvent.getTrackingObject()
  );
};

const trackCheckoutCompleteEvent = event => {
  const checkoutCompleteEvent = new EventModel(
    `Confirmation Modal-Subs`,
    `piano – OTERFAUTP9NV`,
    `puchase success`,
    `confirmation view`,
    `5 | 5`
  );

  checkoutCompleteEvent.addTrackingAttributes({
    id: get(event, 'offerId', 'none'),
    flow: `OTM9MLV5J6M9`,
    product: [
      {
        productInfo: {
          productID: get(event, 'rid', 'none'),
          productName: get(event, 'term.resource.name', 'none'),
          productTerm: get(event, 'termId', 'none'),
          productOffer: get(event, 'offerId', 'none'),
          productBasePrice: get(event, 'chargeAmount', 'none'),
          transaction: get(event, 'termConversionId', 'none'),
          price: get(event, 'chargeAmount', 'none')
        }
      }
    ]
  });

  checkoutCompleteEvent.triggerTrackingEvent(
    'purchased-modal',
    checkoutCompleteEvent.getTrackingObject()
  );
};

const trackCheckoutStageAuth = () => {
  const checkoutStageAuthEvent = new EventModel(
    `Registration Modal-Subs`,
    `piano – OT3P01S6GXVB`,
    `registration view`,
    `registration`,
    `2 | 5`
  );

  // checkoutStageAuthEvent.addTrackingAttributes({
  //   id: eventParams.offerId,
  //   flow: 'OT3P01S6GXVB',
  // });

  checkoutStageAuthEvent.triggerTrackingEvent(
    'registration-modal',
    checkoutStageAuthEvent.getTrackingObject()
  );
};

const trackCheckoutStagePrintAddress = stateView => {
  console.log('🔶checkout state print address!', '\n', stateView);
  const checkoutStagePrintAddress = new EventModel(
    `Shipping Modal-Subs`,
    `piano – OTDB0GHSAQD7`,
    `registration view`,
    `registration`,
    `3 | 5`
  );

  // checkoutStagePrintAddress.addTrackingAttributes({
  //   id: eventParams.offerId,
  //   flow: `OTDB0GHSAQD7`,
  // });

  checkoutStagePrintAddress.triggerTrackingEvent(
    'shipping-modal',
    checkoutStagePrintAddress.getTrackingObject()
  );
};

const trackCheckoutStageState2 = stateView => {
  const checkoutStageState2 = new EventModel(
    `Payment Modal-Subs`,
    `piano – OTM9MLV5J6M9`,
    `payment view`,
    `payment view`,
    `3 | 5`
  );

  checkoutStageState2.addTrackingAttributes({
    id: get(stateView, 'offerId', 'none'),
    flow: `OTM9MLV5J6M9`,
    product: [
      {
        productInfo: {
          productID: get(stateView, 'term.resource.rid', 'none'),
          productName: get(stateView, 'term.resource.name', 'none'),
          productTerm: get(stateView, 'term.termId', 'none'),
          productOffer: get(stateView, 'offerId', 'none'),
          productBasePrice: get(stateView, 'term.totalAmount', 'none')
        }
      }
    ]
  });

  checkoutStageState2.triggerTrackingEvent(
    'payment-modal',
    checkoutStageState2.getTrackingObject()
  );
};

const trackCheckoutStageReceipt = stateView => {
  const checkoutStageReceipt = new EventModel(
    `Confirmation Modal-Subs`,
    `piano – OTERFAUTP9NV`,
    `puchase success`,
    `confirmation view`,
    `5 | 5`
  );

  checkoutStageReceipt.addTrackingAttributes({
    id: get(stateView, 'offerId', 'none'),
    flow: `OTM9MLV5J6M9`,
    product: [
      {
        productInfo: {
          productID: get(stateView, 'term.resource.rid', 'none'),
          productName: get(stateView, 'term.resource.name', 'none'),
          productTerm: get(stateView, 'term.termId', 'none'),
          productOffer: get(stateView, 'offerId', 'none'),
          productBasePrice: get(stateView, 'term.totalAmount', 'none')
          // transaction: get(eventParams, 'termConversionId', 'none'),
          // price: get(eventParams, 'chargeAmount', 'none')
        }
      }
    ]
  });

  checkoutStageReceipt.triggerTrackingEvent(
    'purchased-modal',
    checkoutStageReceipt.getTrackingObject()
  );
};

const trackShippingSaveEvent = event => {
  console.log('🔶 Shipping save event fired:', '\n', event);
  const shippingSaveEvent = new EventModel(
    `Shipping Modal-Subs`,
    `piano – ${get(event, 'params.templateid', 'none')}`,
    `click`,
    `registered`,
    `3 | 5`
  );

  shippingSaveEvent.addTrackingAttributes({
    id: get(event, 'params.offerid', 'none'),
    flow: get(event, 'params.templateid', 'none')
  });

  shippingSaveEvent.triggerTrackingEvent(
    'shipping-save',
    shippingSaveEvent.getTrackingObject()
  );
};

const trackBackButtonClicked = event => {
  console.log('🔶 Back button click event fired:', '\n', event);
  const backButtonClickEvent = new EventModel(
    `Back Icon`,
    `piano – ${get(event, 'params.templateid', 'none')}`,
    `click`,
    `registration`,
    `2 | 5`
  );

  backButtonClickEvent.addTrackingAttributes({
    id: get(event, 'params.offerid', 'none')
  });

  backButtonClickEvent.triggerTrackingEvent(
    'default-click',
    backButtonClickEvent.getTrackingObject()
  );
};

const trackCheckoutSelectTermEvent = termDetails => {
  console.log('🔶 Checkout select term event fired:', '\n', termDetails);
  const checkoutSelectTermEvent = new EventModel(
    `checkout select term`,
    `piano – ${get(termDetails, 'params.templateid', 'none')}`,
    `click`,
    `offer`,
    `1 | 5`
  );

  checkoutSelectTermEvent.addTrackingAttributes({
    id: get(termDetails, 'params.offerid', 'none')
  });

  checkoutSelectTermEvent.triggerTrackingEvent(
    'offer-add',
    checkoutSelectTermEvent.getTrackingObject()
  );
};

export {
  trackShowOfferEvent,
  trackCheckoutCompleteEvent,
  trackCheckoutStageAuth,
  trackCheckoutStagePrintAddress,
  trackCheckoutStageState2,
  trackCheckoutStageReceipt,
  trackBackButtonClicked,
  trackShippingSaveEvent,
  trackCheckoutSelectTermEvent
};
